// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Other/BackButton/BackButton.css */

.app-nav-back-button-wrap {
    position: absolute;
    top: 100%;
    left: 2rem;
    transform: translateY(-50%);
    z-index: 50;
}

.app-nav-back-button {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    border: none;
    outline: none;
    cursor: pointer;
    padding: 0.55rem 1.2rem 0.55rem 0.85rem;
    border-radius: 999px;
    font-size: 0.85rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    color: #ffffff;
    background: linear-gradient(135deg, #ff8a65 0%, #ef6f53 45%, #e73710 100%);
    box-shadow:
        0 6px 14px rgba(231, 55, 16, 0.35),
        0 2px 4px rgba(0, 0, 0, 0.12);
    transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease, background 0.2s ease;
}

.app-nav-back-button-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.22);
    transition: transform 0.25s ease;
}

.app-nav-back-button-icon i {
    font-size: 0.75rem;
}

.app-nav-back-button:hover {
    color: #ffffff;
    background: linear-gradient(135deg, #ff7a47 0%, #e65a2e 45%, #c92a0f 100%);
    transform: translateY(-2px) scale(1.04);
    box-shadow:
        0 10px 20px rgba(231, 55, 16, 0.5),
        0 3px 6px rgba(0, 0, 0, 0.15);
}

.app-nav-back-button:hover .app-nav-back-button-icon {
    transform: translateX(-3px);
}

.app-nav-back-button:active {
    transform: translateY(0) scale(0.97);
    box-shadow:
        0 4px 8px rgba(231, 55, 16, 0.35),
        0 1px 2px rgba(0, 0, 0, 0.12);
}

.app-nav-back-button:focus-visible {
    box-shadow:
        0 0 0 3px rgba(239, 111, 83, 0.35),
        0 6px 14px rgba(231, 55, 16, 0.35);
}

@media (max-width: 820px) {
    .app-nav-back-button-wrap {
        left: 1rem;
    }

    .app-nav-back-button {
        padding: 0.45rem 1rem 0.45rem 0.7rem;
        font-size: 0.78rem;
    }
}

@media (max-width: 560px) {
    .app-nav-back-button-wrap {
        top: calc(100% + 2px);
        transform: none;
        left: 0.75rem;
    }

    .app-nav-back-button-label {
        display: none;
    }

    .app-nav-back-button {
        padding: 0.5rem;
    }

    .app-nav-back-button-icon {
        width: 20px;
        height: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Other/BackButton/BackButton.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,uCAAuC;IACvC,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,0EAA0E;IAC1E;;qCAEiC;IACjC,6FAA6F;AACjG;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,0EAA0E;IAC1E,uCAAuC;IACvC;;qCAEiC;AACrC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC;;qCAEiC;AACrC;;AAEA;IACI;;0CAEsC;AAC1C;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,oCAAoC;QACpC,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":["/* src/components/routes/Other/BackButton/BackButton.css */\n\n.app-nav-back-button-wrap {\n    position: absolute;\n    top: 100%;\n    left: 2rem;\n    transform: translateY(-50%);\n    z-index: 50;\n}\n\n.app-nav-back-button {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    padding: 0.55rem 1.2rem 0.55rem 0.85rem;\n    border-radius: 999px;\n    font-size: 0.85rem;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    color: #ffffff;\n    background: linear-gradient(135deg, #ff8a65 0%, #ef6f53 45%, #e73710 100%);\n    box-shadow:\n        0 6px 14px rgba(231, 55, 16, 0.35),\n        0 2px 4px rgba(0, 0, 0, 0.12);\n    transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease, background 0.2s ease;\n}\n\n.app-nav-back-button-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.22);\n    transition: transform 0.25s ease;\n}\n\n.app-nav-back-button-icon i {\n    font-size: 0.75rem;\n}\n\n.app-nav-back-button:hover {\n    color: #ffffff;\n    background: linear-gradient(135deg, #ff7a47 0%, #e65a2e 45%, #c92a0f 100%);\n    transform: translateY(-2px) scale(1.04);\n    box-shadow:\n        0 10px 20px rgba(231, 55, 16, 0.5),\n        0 3px 6px rgba(0, 0, 0, 0.15);\n}\n\n.app-nav-back-button:hover .app-nav-back-button-icon {\n    transform: translateX(-3px);\n}\n\n.app-nav-back-button:active {\n    transform: translateY(0) scale(0.97);\n    box-shadow:\n        0 4px 8px rgba(231, 55, 16, 0.35),\n        0 1px 2px rgba(0, 0, 0, 0.12);\n}\n\n.app-nav-back-button:focus-visible {\n    box-shadow:\n        0 0 0 3px rgba(239, 111, 83, 0.35),\n        0 6px 14px rgba(231, 55, 16, 0.35);\n}\n\n@media (max-width: 820px) {\n    .app-nav-back-button-wrap {\n        left: 1rem;\n    }\n\n    .app-nav-back-button {\n        padding: 0.45rem 1rem 0.45rem 0.7rem;\n        font-size: 0.78rem;\n    }\n}\n\n@media (max-width: 560px) {\n    .app-nav-back-button-wrap {\n        top: calc(100% + 2px);\n        transform: none;\n        left: 0.75rem;\n    }\n\n    .app-nav-back-button-label {\n        display: none;\n    }\n\n    .app-nav-back-button {\n        padding: 0.5rem;\n    }\n\n    .app-nav-back-button-icon {\n        width: 20px;\n        height: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
